export default {
  selector: {
    usersGroupHeader: 'Users',
    groupsGroupHeader: 'Groups',
    notFoundOnlyUsers: 'No users matching your search criteria',
    notFoundWithGroups: 'No users or groups matching your search criteria',
    loginMethodTooltip: 'Login method used by this user'
  }
}
